// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"styles_hamburger__DMhJJ","hamburgerIcon":"styles_hamburgerIcon__1bz5r","hamburgerMenu":"styles_hamburgerMenu__10S4W","panel":"styles_panel__3LXMy"};